let translation = {}

export function setTranslation (list) {
    translation = list;
}

export function translate (label: string, ...params: any) {
    console.log(label, translation)
    label = (translation[label] ?? label).replace();
    if (Array.isArray(params)) {
        params.forEach((item) => {
            label = label.replace(':?', item);
        });
    }
    return label;
}

export const lang = document.documentElement.lang;
export const isEn = document.documentElement.lang.toLowerCase() === 'en';
export const isAr = document.documentElement.lang.toLowerCase() === 'ar';
